module.exports = __webpack_public_path__ + "static/media/Jon Snow 3.8d1f775b.jpg";